// Applique la remise de l'offre de lancement (-20%), arrondie aux 10 centimes les plus proches.
export function discountedPrice(price: string): string {
  const num = parseFloat(price.replace('€', ''));
  const rounded = Math.round(num * 0.8 * 10) / 10; // arrondi au dixième
  return '€' + rounded.toFixed(2);
}